import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { Input, InputGroup, InputGroupAddon, InputGroupText, Table } from 'reactstrap';
import { Card, CardHeader, CardBody, CardText, CardFooter } from 'reactstrap';
import logo from './Imagenes/Iconos/ESPOL-ExperienciaEstudiantil.svg';
import url from "./variables/url.js";
import "react-pro-sidebar/dist/css/styles.css";
/*import pdfPrueba from './Content/plantilla.pdf';*/
import './PDF.css';
import AllPagesPDFViewer from './All-page';
import Certificado from './Certificado';
import SinglePagePDFViewer from './Single-page';

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

const ColoredLine = ({ color }) => (
    <hr
        style={{
            color: color,
            backgroundColor: color,
            height: 2
        }}
    />
);

export class LayoutExterno extends Component {
    static displayName = LayoutExterno.name;

    constructor(props) {
        super(props);
        this.state = {
            armado: 0,
            codigo: '',            
        };
    }

    componentDidMount() {
      var params = window.location.pathname.split('/');
      var codigo = params[params.length - 1];

        //console.log('codigo: ', url);        
        //this.setState({codigo: url});
      this.setState({ codigo: codigo });
    }

    render() {
      var url = this.state.codigo;
    return (
        <div className="wrapper">  
            <div className="main-panel" >
                <header>
                    <Row>
                        <Col>
                            <img src={logo} style={{ width: "75%", height: "100%" }} />
                        </Col>
                        <Col>                            
                        </Col>
                    </Row>
                    <ColoredLine color="#010453" />                    
                </header>
                <Row style={{ minHeight: '75vh' }}>
                    <Col>
              {url && <Certificado cod={url} />}
                    </Col>                    
                </Row>
                <p style={{
                    color: "#ffffff",
                    textAlign: "center",
                    fontSize: '0.65em',
                    background: '#233364'
                }}>
                    Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
                    <br />
                    &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
                    <br />
                    Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.
                </p>
            </div>
        </div>
    );
  }
}
